import { render, staticRenderFns } from "./CancellationBooking.vue?vue&type=template&id=96f432fc&scoped=true&"
import script from "./CancellationBooking.vue?vue&type=script&lang=js&"
export * from "./CancellationBooking.vue?vue&type=script&lang=js&"
import style0 from "./CancellationBooking.vue?vue&type=style&index=0&id=96f432fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f432fc",
  null
  
)

export default component.exports